import { useEffect, useState } from 'react';

// Whether the viewport matches a media query, kept up to date on resize
export function useMatchesMedia(query: string) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const listener = (event: MediaQueryListEvent) => setMatches(event.matches);
        mediaQuery.addEventListener('change', listener);
        setMatches(mediaQuery.matches);
        return () => mediaQuery.removeEventListener('change', listener);
    }, [query]);

    return matches;
}
